<template>
  <pack>
    <zt-title>充值统计</zt-title>

    <!-- 搜索器 -->
    <form class="form" @submit.native.prevent @keyup.enter.exact="seach">
      <el-date-picker
        v-model="seeker.time"
        type="daterange"
        range-separator="至"
        start-placeholder="充值时间"
        end-placeholder="充值时间"
        value-format="yyyy-MM-dd"
      ></el-date-picker>
      <span>充值状态:</span>
      <el-select v-model="seeker.status" class="select" placeholder="请选择">
        <el-option
          v-for="item in status_list"
          :key="item.label"
          :label="item.label"
          v-model="item.value"
        ></el-option>
      </el-select>
      <span>手机号:</span>
      <zt-input placeholder="请输入手机号" v-model.trim="seeker.telephone"></zt-input>
      <zt-button type="primary" @click.exact.enter="seach">搜索</zt-button>
      <zt-button @click="clear">清空</zt-button>
      <zt-button @click="outputData" type="primary" class="fr">导出数据</zt-button>
    </form>

    <!-- 表格 -->
    <el-table :data="list" ref="table" class="table" :load="loading" @sort-change="sortChange">
      <el-table-column label="昵称" prop="taobao_nickname" />
      <el-table-column label="手机号" prop="telephone" />
      <el-table-column sortable="custom" label="充值金额" prop="money" />
      <el-table-column label="充值状态">
        <template slot-scope="{row}">
          <span :class="`status${row.status}`">{{row.status|formatStatus}}</span>
        </template>
      </el-table-column>
      <el-table-column sortable="custom" prop="add_time" label="发起时间" />
    </el-table>

    <!-- 分页器 -->
    <div class="pagination">
      <el-pagination
        @size-change="onSizeChange"
        @current-change="onCurrentChange"
        :current-page="pagination.page"
        :page-sizes="pagesize"
        :page-size="pagination.pagesize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pagination.recordcount"
      ></el-pagination>
    </div>
  </pack>
</template>

<script>
import dayjs from 'dayjs';
import { download } from '@/utils/download';
import { admin_money_log } from '@/api/dataStatistics';
export default {
  filters: {
    formatStatus(status) {
      return status === 0 ? '支付中' : '支付成功';
    },
  },
  data: () => ({
    orderby: 1,
    seeker: {
      telephone: '',
      status: '',
      time: '',
    },
    loading: false,
    list: [],
    status_list: [
      {
        value: '',
        label: '全部',
      },
      {
        value: 0,
        label: '支付中',
      },
      {
        value: 1,
        label: '支付成功',
      },
    ],
    pagesize: [10, 20, 30, 40],
    pagination: {
      page: 1, // 当前页
      pagesize: 10, // 每页大小
      pagecount: 1, // 总页数
      recordcount: 0, // 总条数
    },
  }),
  methods: {
    //下载数据
    outputData() {
      if (!this.seeker.time) {
        return this.$message.error('请选择充值时间');
      }
      const time1 = dayjs(this.seeker.time[0]);
      const time2 = dayjs(this.seeker.time[1]);
      /* 超过3个月 */
      if (time2.diff(time1, 'day') > 93) {
        this.seeker.time = '';
        return this.$message.error('导出数据时间跨度不能超过3个月');
      }
      if (this.seeker.time != '' && this.seeker.time != null) {
        if (this.seeker.time[1].indexOf(' 23:59:59') == -1) {
          this.seeker.time[1] += ' 23:59:59';
        }
      }
      admin_money_log(
        {
          ...this.seeker,
          add_time_from: this.seeker.time[0] || '',
          add_time_to: this.seeker.time[1] || '',
          pagesize:100000,
          order: this.orderby,
          export: 1,
        },
        {
          config: {
            responseType: 'blob',
          },
        }
      ).then(({ data }) => {
        if (data.type == 'application/json') {
          this.$message.error('暂无数据');
          return;
        }
        download(
          data,
          '主推淘客会员充值情况.xlsx',
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        );
      });
    },
    seach() {
      this.pagination = {
        page: 1, // 当前页
        pagesize: 10, // 每页大小
        pagecount: 1, // 总页数
        recordcount: 0, // 总条数
      };

      this.getList();
    },

    sortChange(e) {
      const { prop, order } = e;
      if (!prop || !order) {
        this.orderby = 1;
      }
      if (prop === 'add_time') {
        this.orderby = order === 'descending' ? 10 : 9;
      }
      if (prop === 'money') {
        this.orderby = order === 'descending' ? 3 : 4;
      }
      this.getList();
    },

    clear() {
      this.seeker = {
        telephone: '',
        status: '',
      };
      this.orderby = 1;
      this.$refs.table.clearSort();
      this.getList();
    },

    //获取数据
    getList() {
      this.loading = true;
      if (this.seeker.time != '' && this.seeker.time != null) {
        if (this.seeker.time[1].indexOf(' 23:59:59') == -1) {
          this.seeker.time[1] += ' 23:59:59';
        }
      }
      admin_money_log({
        ...this.seeker,
        ...this.pagination,
        add_time_from: this.seeker.time[0] || '',
        add_time_to: this.seeker.time[1] || '',
        orderby: this.orderby,
      }).then(({ data }) => {
        if (data.error_code == 0) {
          this.pagination.recordcount = data.recordcount;
          this.pagination.pagecount = data.pagecount;
          this.list = data.data;
          this.loading = false;
        }
      });
    },

    // 更改 - 分页大小
    onSizeChange(pagesize) {
      this.pagination.pagesize = pagesize;
      this.getList();
    },

    // 更改 - 当前页
    onCurrentChange(page) {
      this.pagination.page = page;
      this.getList();
    },
  },
  watch: {
    'seeker.telephone'(val) {
      if (val.indexOf(' ') !== -1) {
        this.seeker.telephone = this.seeker.telephone.replace(/\s+/g, '');
      }
    },
  },
  mounted() {
    this.getList();
  },
};
</script>

<style lang="scss" scoped>
@import "~@/styles/table.scss";
/deep/ .el-table--enable-row-hover .el-table__body tr:hover > td {
  background: #f7f2ff;
}
.select-type {
  width: 110px;
}
.select {
  width: 165px;
}

.download-form {
  display: inline-block;
  vertical-align: top;
}
.download-btn {
  color: #fff;
  border-radius: 4px;
  border: none;
  padding: 12px 20px;
  cursor: pointer;
  font-size: 14px;
  background: linear-gradient(135deg, #b27dff 0%, #d460cf 100%);
  &:hover {
    background: linear-gradient(
      135deg,
      rgba(178, 125, 255, 0.8) 0%,
      rgba(212, 96, 207, 0.8) 100%
    );
  }
}
.hideInput {
  padding: 0px;
  border: none;
  width: 0px;
  height: 0px;
}
.form {
  margin-top: 30px;
  font-size: 12px;
  span {
    display: inline-block;
    margin-left: 15px;
    margin-right: 5px;
  }
  /deep/ .zt-input {
    width: 139px;
    margin-right: 15px;
  }
  /deep/ .zt-button {
    margin-right: 5px;
  }
}
.table {
  text-align: center;
  margin-top: 30px;
}
.status1 {
  color: $theme-green;
}
.status0 {
  color: $theme-orange;
}
</style>